module.exports = __webpack_public_path__ + "img/spinner.76c7c062.svg";